export default __webpack_public_path__ + "static/media/illustration_news-articles.ace0fb96.png";